module.exports = __webpack_public_path__ + "static/media/ePosterMallSquare.c9924785.jpg";